import { ReactNode } from 'react';

export const InviteEventGuideline = () => {
  return (
    <div className={'flex w-full flex-col items-center bg-[#F2F3F4] py-12'}>
      <div className={'w-full max-w-[520px] px-6'}>
        <div className={'text-16 pb-3 pt-5 font-bold text-gray-900'}>친구초대 유의사항</div>
        <ol className={'text-14 ml-4.5 mb-2 flex list-outside list-disc flex-col gap-2 text-[#5C6267]'}>
          <GuidelineItem>친구가 초대 링크를 통해 환급 조회를 완료해야 스탬프를 적립받을 수 있어요.</GuidelineItem>
          <GuidelineItem>친구가 다른 경로를 통해 이미 환급 조회를 완료한 경험이 있다면 스탬프가 적립되지 않아요.</GuidelineItem>
          <GuidelineItem>초대받은 계정 기준으로 최대 1회만 스탬프가 적립돼요.</GuidelineItem>
          <GuidelineItem>한 개의 사업자를 여러 계정이 조회하는 경우, 최초 조회한 계정에 한해 스탬프가 적립돼요</GuidelineItem>
        </ol>
        <div className={'text-16 pb-3 pt-5 font-bold'}>꼭 읽어주세요!</div>
        <ol className={'text-14 ml-4.5 mb-2 flex list-outside list-disc flex-col gap-2 text-[#5C6267]'}>
          <GuidelineItem>이벤트 참여 시 경품 발송을 위해 개인정보 수집 및 이용 동의가 필요해요.</GuidelineItem>
          <GuidelineItem>네이버페이는 친구 초대가 성공한 다음달 10일 이내에 문자로 일괄 지급해드려요.</GuidelineItem>
          <GuidelineItem>상품을 받지 못했다면 발송번호(1599-6567)가 스팸 처리 되었는지 확인해주세요.</GuidelineItem>
          <GuidelineItem>지급된 상품의 유효기간은 지급일로부터 최대 30일입니다. 유효기간이 만료될 경우, 재발송되지 않아요.</GuidelineItem>
          <GuidelineItem>상품은 비즈넵 환급에 가입된 휴대폰번호로 발송돼요.</GuidelineItem>
          <GuidelineItem>친구가 초대 링크를 통해 환급금을 조회하지 않으면 경품 지급이 제한돼요.</GuidelineItem>
          <GuidelineItem>이벤트 혜택을 제공하기 전 서비스를 탈퇴하는 경우 대상에서 제외돼요.</GuidelineItem>
          <GuidelineItem>이 이벤트는 당사 사정에 따라 사전 안내 없이 변경·중단될 수 있어요.</GuidelineItem>
        </ol>
      </div>
    </div>
  );
};

const GuidelineItem = ({ children }: { children: ReactNode }) => {
  return <li className={'break-all'}>{children}</li>;
};
